if (typeof document === "undefined") return;
var createStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject
) {
	var linkTag = document.createElement("link");
	
	linkTag.rel = "stylesheet";
	linkTag.type="text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}

	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;
	if (linkTag.href.indexOf(window.location.origin + '/') !== 0) {
  linkTag.crossOrigin = "anonymous";
}
	if (oldTag) {
  oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
} else {
  document.head.appendChild(linkTag);
}
	return linkTag;
}
var findStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (dataHref) {
			dataHref = dataHref.split('?')[0]
		}
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var loadStylesheet = function (chunkId) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	"main": 0,

};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {
"node_modules_gbm_starman-next__internal_duotone_module-D3AmPPmG_es_js": 1,
"src_bootstrap_tsx": 1,
"node_modules_gbm_starman-next__internal_fill_module-Cip0oxWi_es_js": 1,
"node_modules_gbm_starman-next_index_mjs": 1,
"node_modules_gbm_starman-next__internal_light_module-DdnZKP4I_es_js": 1,
"node_modules_gbm_starman-next__internal_regular_module-BCKAOSNJ_es_js": 1,
"node_modules_gbm_starman-next__internal_thin_module-CAkXO2bV_es_js": 1,
"checkbookEvents_src_remote-entry_ts-_f8050": 1,
"contracts_src_remote-entry_ts-_9a1e0": 1,
"crdCredits_src_remote-entry_ts-_b31f0": 1,
"home_src_remote-entry_ts-_87821": 1,
"paymentOperations_src_remote-entry_ts-_47ba1": 1,
"eventsApprovals_src_remote-entry_ts-_6d2f1": 1,
"contracts_src_remote-entry_ts-_9a1e1": 1,
"reports_src_remote-entry_ts-_fb301": 1,
"checkbookEvents_src_remote-entry_ts-_f8051": 1,
"crdDashboard_src_remote-entry_ts-_2a011": 1,
"crdCredits_src_remote-entry_ts-_b31f1": 1,
"crdDetails_src_remote-entry_ts-_87af1": 1,
"crdDashboard_src_remote-entry_ts-_2a010": 1,
"crdDetails_src_remote-entry_ts-_87af0": 1,
"eventsApprovals_src_remote-entry_ts-_6d2f0": 1,
"home_src_remote-entry_ts-_87820": 1,
"paymentOperations_src_remote-entry_ts-_47ba0": 1,
"reports_src_remote-entry_ts-_fb300": 1,
"node_modules_gbm_starman-next__internal_bold_module-4N29tnue_es_js": 1,

};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = loadStylesheet(chunkId).then(
				function() {
					installedCssChunks[chunkId] = 0;
				},
				function(e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

// no hmr
